import React, { Component } from 'react';
import { SimpleForm, TextInput, NumberInput, Toolbar, SaveButton, translate } from 'react-admin';
import FieldGroup from '~components/FieldGroup';
import { isRequired } from '~utils/inputValidations';

function EtapaToolbar(props) {
  return (
    <Toolbar {...props}>
      <SaveButton />
    </Toolbar>
  );
}

class EtapaForm extends Component {
  render() {
    return (
      <SimpleForm {...this.props} toolbar={<EtapaToolbar />}>
        {this.props.children}
        <FieldGroup label="fieldGroups.etapaEs">
          <TextInput source="name" validate={isRequired} />
        </FieldGroup>
        <FieldGroup label="fieldGroups.etapaEn">
          <TextInput source="nameEn" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.etapaPt">
          <TextInput source="namePt" />
        </FieldGroup>
        <FieldGroup label="fieldGroups.etapa">
          <NumberInput source="order" />
        </FieldGroup>
      </SimpleForm>
    );
  }
}

export default translate(EtapaForm);
